import flagus from "../images/flags/us.svg";
import flagspain from "../images/flags/spain.svg";


const languages = {
  sp: {
    label: "Español",
    flag: flagspain,
  },
  en: {
    label: "English",
    flag: flagus,
  },
}

export default languages
